import moment from 'moment-timezone'

import { CANNOT_VERIFY_WITHIN } from './constants'

// Taken from: https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch08s15.html
const DOMAIN_REGEX = /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/

export const validDomain = (domain) => {
  if (domain == null) {
    return false
  }

  const lowercaseDomain = domain.toLowerCase()

  if (lowercaseDomain.startsWith('www.')) {
    return false
  }

  return DOMAIN_REGEX.test(domain)
}

export const canTryVerifyByTimeframe = (lastCheckedAt) => {
  if (lastCheckedAt == null) {
    return true
  }

  const withinUtcMoment = moment().utc().subtract(CANNOT_VERIFY_WITHIN.amount, CANNOT_VERIFY_WITHIN.unit)
  const lastCheckedAtMoment = moment(lastCheckedAt).utc()

  return withinUtcMoment.isAfter(lastCheckedAtMoment)
}
